import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import SectionService from '@/core/services/section.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateSectionComponent extends Vue {

  sectionService: any = new SectionService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  surveyList: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  survey: string = "";
  title: string = "";
  company: string = "";
  instructions: string = "";


  mounted (){
    const _ = this;
    _.getBySurvey();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getBySurvey(){
    const _ = this;
    _.isLoading = true;
    _.sectionService.getBySurvey().then((data: any) => {
      _.surveyList = data['data'].surveys;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      _.isLoading = false;
    })
  }

  create(){
    const _ = this;
    let section = {
      title: _.title,
      instructions: _.instructions
    };
    console.log(section);
    _.isLoading = true;
    _.sectionService.create(section).then((data: any) => {
      console.log(data);
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push(`${data['data'].section.id}/question/create`);
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  validations(title = ''){
    const _ = this;
    _.genericErr = [];
    if(title == ''){
      _.genericErr.push("Por favor introduce un nombre");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
